import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import Dialog from "components/dialog";

const parseEvuJson = evuJson => {
  try {
    return JSON.parse(evuJson);
  } catch (error) {
    console.error(error);
    console.error("Above error was thrown parsing Evu Json: ", evuJson);
  }
  // We suppose by default that is a local instance, and we show the warning
  return { instance: true };
};

const WarningLocalUrl = ({ children, event, intl, history }) => {
  const [show, setShow] = useState(false);

  // event.evu se resuelve de forma asíncrona e independiente del resto del evento
  // (useEventDetailsRest), así que puede llegar después del primer render: no se puede
  // calcular `show` una sola vez en el useState inicial, hay que reaccionar al valor real.
  useEffect(
    () => {
      const evu = parseEvuJson(event.evu);
      setShow(!!(evu && evu.hasOwnProperty("instance")));
    },
    [event.evu],
  );

  const handleHideWarning = useCallback(() => setShow(false), []);
  const handleReturn = useCallback(() => history.goBack(), [history]);

  return show ? (
    <Dialog
      onClose={handleReturn}
      onAccept={handleHideWarning}
      open={show}
      disableBackdropClick
      disableEscapeKeyDown
      title={intl.formatMessage({ id: "common.warning" })}
    >
      <FormattedMessage id="app.event.liveEmission.localserver.warning" />
    </Dialog>
  ) : (
    children
  );
};

WarningLocalUrl.propTypes = {
  /**
   * Data to represent
   **/
  event: PropTypes.object,
};

export default withRouter(injectIntl(WarningLocalUrl));
